import { 
	PhoenixUser,
	GroupSharePermissions,
	GroupShareTriState,
	UserGroupPolicy 
} from 'phoenix/domain';

export class UserGroup {
	constructor(
		public id:number = null, 
		public name:string = '', 
		public users:PhoenixUser[] = [], 
		public isSystemGroup:boolean = false
	){
		if (users && users.length > 0) {
			users.sort((a, b) => {
				let aName = (a.UserName as string).toLocaleLowerCase();
				let bName = (b.UserName as string).toLocaleLowerCase();
				
				if(aName === bName) {
					return 0;
				} else {
					return aName > bName ? 1 : -1;
				}
					
			});
		}
	}

	public toServer() {
		return {
			UserGroupId: this.id,
			UserGroupName: this.name,
			Embedded: {
				Users : this.users
			}					
		};
	}

	public contains(user:PhoenixUser) {
		var contains = false;
		for (var i = 0; i < this.users.length; i++) {
			if (this.users[i].UserId === user.UserId) {
				contains = true;
				break;
			}
		}
		return contains;
	}
}

export class UserGroupShareRight {
	public triState:GroupShareTriState = GroupShareTriState.No;
	public get canEdit() {
		return angular.isFunction(this.validator) ? !!this.validator.call(this) : true;
	};

	constructor(
		public readonly value:GroupSharePermissions,
		public readonly label:string,		
		private validator?:()=>boolean
	){}


	public applyPermissions(allowBits:number, denyBits:number){
		if((this.value & denyBits) !== 0){
			this.triState = GroupShareTriState.Never;
		}
		else if ((this.value & allowBits) !== 0) {
			this.triState = GroupShareTriState.Yes;
		}
		else {
			this.triState = GroupShareTriState.No;
		}
	}		
}

export class UserGroupShareRightCollection {
	private gettextCatalog:ng.gettext.gettextCatalog;
	private _rights: UserGroupShareRight[] = [];

	public get rights() {
		return this._rights;
	}

	
	constructor(allowBits:number, denyBits:number, gettextCatalog:ng.gettext.gettextCatalog){
		this.gettextCatalog = gettextCatalog;

		let shareViewLink = new UserGroupShareRight(GroupSharePermissions.ReshareExternallyView, this.gettextCatalog.getString('Share a view link'));
		let shareEditLink = new UserGroupShareRight(GroupSharePermissions.ReshareExternallyEdit, this.gettextCatalog.getString('Share an edit link'), () => {
			return shareViewLink.triState === GroupShareTriState.Yes && 
				giveDownloadRight.triState === GroupShareTriState.Yes && 
				giveUploadRight.triState === GroupShareTriState.Yes;
		});
		let giveDownloadRight =	new UserGroupShareRight(GroupSharePermissions.GrantDownloadExternally, this.gettextCatalog.getString('Give link visitors the right to download'), () =>{
			return shareViewLink.triState === GroupShareTriState.Yes;
		});
		let giveUploadRight = new UserGroupShareRight(GroupSharePermissions.GrantUploadExternally, this.gettextCatalog.getString('Give link visitors the right to upload'), () => {
			return shareViewLink.triState === GroupShareTriState.Yes;
		});

		this._rights.push(shareViewLink, giveDownloadRight, giveUploadRight, shareEditLink);
		this._rights.forEach(right => {
			right.applyPermissions(allowBits, denyBits);
		});
	}

	generatePermissions(){
		return this.rights.reduce((perms, right)=> {
			switch(right.triState) {
				case GroupShareTriState.Yes:
					perms.allow |= right.value;
					break;
				case GroupShareTriState.Never:
					perms.deny |= right.value;
					break;
			}
			
			return perms;
		}, {
			allow: 0,
			deny: 0
		});
	}

	cascadePermissionChanges() {
			let shareViewLinkRight = this.rights.find(v => v.value === GroupSharePermissions.ReshareExternallyView);
			let shareEditLinkRight = this.rights.find(v => v.value === GroupSharePermissions.ReshareExternallyEdit)
			let downloadLinkRight = this.rights.find(v => v.value === GroupSharePermissions.GrantDownloadExternally);
			let uploadLinkRight = this.rights.find(v => v.value === GroupSharePermissions.GrantUploadExternally);

			if (shareViewLinkRight.triState === GroupShareTriState.No) {
				this.rights.forEach((value:UserGroupShareRight) => {
					if (value.triState === GroupShareTriState.Yes)
					value.triState = GroupShareTriState.No;
				})
			} else if (shareViewLinkRight.triState === GroupShareTriState.Never) {
				this.rights.forEach((value:UserGroupShareRight) => {
					value.triState = GroupShareTriState.Never;
				})
			} else if (uploadLinkRight.triState === GroupShareTriState.Never || downloadLinkRight.triState === GroupShareTriState.Never) {
				shareEditLinkRight.triState = GroupShareTriState.Never;
			} else if (uploadLinkRight.triState === GroupShareTriState.No || downloadLinkRight.triState === GroupShareTriState.No) {
				shareEditLinkRight.triState = GroupShareTriState.No;
			}
	}
}



// WEBPACK FOOTER //
// ./src/sharebase/domain/userGroup.ts